<script>
    import { getContext } from 'svelte';

    import { TABS } from './Tabs.svelte';

    export let key;
    export let label;
    export let component = null;

    const { registerTab, selectTab, selectedTab } = getContext(TABS);
    const thisTab = { key, component, props: $$restProps }
    registerTab(thisTab);

</script>

<style>
    .nav-item button.nav-link.nav-link.active {
        color: #fff;
        background-color: #dd5900;
        
    }

    .nav-item button.nav-link.nav-link {
        color: #dd5900;
        border: 0;
    }

    .nav-item button:focus {
        outline: 0;
    }
</style>

<li class="nav-item">
	<button
		class="nav-link"
		class:active={$selectedTab === thisTab}
		on:click={() => selectTab(thisTab)}
	>
		{label}
	</button>
</li>
